'use es6';

import { fetchProfileReviews, fetchProfileReviewStats, writeProfileReview, toggleHelpful } from '../clients/ecosystemClient';
import { reportReview, reportReply } from '../clients/qualityClient';
import * as ActionTypes from './ActionTypes';
import I18n from 'I18n';
const notificationsKey = 'ecosystem-marketplace-solutions-ui.profile.reviews';
export const getProfileReviews = queries => dispatch => {
  dispatch({
    type: ActionTypes.PROFILE_REVIEWS_REQUESTED
  });
  return fetchProfileReviews(queries).then(resp => {
    dispatch({
      type: ActionTypes.PROFILE_REVIEWS_RECEIVED,
      payload: resp
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.PROFILE_REVIEWS_FAILED,
      payload: error
    });
  });
};
export const getProfileReviewStats = profileId => dispatch => {
  dispatch({
    type: ActionTypes.PROFILE_REVIEW_STATS_REQUESTED
  });
  return fetchProfileReviewStats(profileId).then(resp => {
    dispatch({
      type: ActionTypes.PROFILE_REVIEW_STATS_RECEIVED,
      payload: resp
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.PROFILE_REVIEW_STATS_FAILED,
      payload: error
    });
  });
};
export const resetProfileReviewsStatus = () => ({
  type: ActionTypes.PROFILE_REVIEWS_RESET
});
export const resetProfileReviewStatsStatus = () => ({
  type: ActionTypes.PROFILE_REVIEW_STATS_RESET
});
export const resetProfileReviewFilters = () => ({
  type: ActionTypes.PROFILE_REVIEW_FILTERS_RESET
});
export const submitProfileReview = review => dispatch => {
  dispatch({
    type: ActionTypes.PROFILE_REVIEW_SUBMIT_REQUESTED
  });
  return writeProfileReview(review).then(resp => {
    dispatch({
      type: ActionTypes.PROFILE_REVIEW_SUBMIT_RECEIVED,
      payload: resp
    });
    return resp;
  }).catch(err => {
    dispatch({
      type: ActionTypes.PROFILE_REVIEW_SUBMIT_FAILED,
      payload: err,
      error: true
    });
    throw err;
  });
};

const getReportErrorKey = err => {
  if (err.responseJSON && err.responseJSON.message && err.responseJSON.message.includes('already reported')) {
    return 'duplicate_error';
  } else if (err.responseJSON && err.responseJSON.category === 'RATE_LIMITS') {
    return 'report_limit_error';
  }

  return 'error';
};

const genericReportAction = (actionPrefix, apiMethod, data) => dispatch => {
  dispatch({
    type: ActionTypes[`${actionPrefix}_REQUESTED`]
  });
  return apiMethod(data).then(resp => {
    dispatch({
      type: ActionTypes[`${actionPrefix}_RECEIVED`],
      payload: resp,
      meta: {
        notification: {
          titleText: I18n.text(`${notificationsKey}.report.success.titleText`),
          message: I18n.text(`${notificationsKey}.report.success.message`)
        }
      }
    });
  }).catch(err => {
    const errorKey = getReportErrorKey(err);
    dispatch({
      type: ActionTypes[`${actionPrefix}_FAILED`],
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.report.${errorKey}.titleText`),
          message: I18n.text(`${notificationsKey}.report.${errorKey}.message`)
        }
      }
    });
  });
};

export const reportProfileReview = data => dispatch => {
  dispatch(genericReportAction('PROFILE_REVIEW_REPORT', reportReview, data));
};
export const reportProfileReply = data => dispatch => {
  dispatch(genericReportAction('PROFILE_REVIEW_REPORT_REPLY', reportReply, data));
};
export const toggleReviewHelpful = (reviewId, userId, isHelpful) => dispatch => {
  dispatch({
    type: ActionTypes.PROFILE_REVIEW_HELPFUL_REQUESTED
  });
  toggleHelpful(reviewId, isHelpful).then(() => {
    dispatch({
      type: ActionTypes.PROFILE_REVIEW_HELPFUL_RECEIVED,
      payload: {
        reviewId,
        userId,
        isHelpful
      }
    });
  }).catch(err => {
    dispatch({
      type: ActionTypes.PROFILE_REVIEW_HELPFUL_FAILED,
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.helpful.error.titleText`),
          message: I18n.text(`${notificationsKey}.helpful.error.message`)
        }
      }
    });
  });
};
export const updateReviewFilters = updates => ({
  type: ActionTypes.PROFILE_REVIEW_FILTERS_UPDATED,
  payload: updates
});